import { getPlayerData } from "core-integration/src/store/player/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Register from "../player/Register";
import CreateEntryDialog from "./CreateEntryDialog";
import { IListTableProps } from "./CreateSquad";
import SquadBase from "./SquadBase";
import SquadListTable from "./SquadListTable";

const SquadSelection = () => {
  const { t } = useTranslation();
  const player = useSelector(getPlayerData);
  if (!player || player.dirty) {
    return <Register />;
  }
  return (
    <SquadBase
      contentTitle="roster selection"
      showListTableAsDefault={false}
      listTable={(listTableProps: IListTableProps) => (
        <SquadListTable {...listTableProps} />
      )}
      scoreboard="basic"
      submitDialog={(handleHide: () => void) => (
        <CreateEntryDialog handleHide={handleHide} />
      )}
      title={t("squad.titlen", "Roster Selection")}
    />
  );
};

export default SquadSelection;
